export default __webpack_public_path__ + "static/media/live-feed-lock-close.42e6f0d4.svg";